import React from "react"
import {Meta} from "../../resources/common"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import UnifiedApplicationRow from "./UnifiedApplicationRow"
import {AllowedUnifiedApplicationsColumns, UnifiedApplication} from "../../resources/unifiedApplication"

interface UnifiedApplicationsTableProps {
	unifiedApplications: Array<UnifiedApplication>
	orgNames: Map<string, string>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	includedColumns: Array<AllowedUnifiedApplicationsColumns>
	fullHeight?: boolean
	showTabsOnHeader?: boolean
	meta?: Meta
}

export default function UnifiedApplicationsTable({
	unifiedApplications,
	orgNames,
	hasResults,
	hasPrev,
	hasNext,
	prev,
	next,
	includedColumns,
	fullHeight,
	showTabsOnHeader,
	meta,
}: UnifiedApplicationsTableProps) {
	return (
		<div className={"unified-applications-table"}>
			<DataTable
				isEmpty={unifiedApplications.length === 0}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				stickyActionWithTabsOnHeader={fullHeight && showTabsOnHeader}
				noContentText={"No unified applications found"}
			>
				<DataTableHead>
					<DataTableRow>
						{includedColumns.map((column) => (
							<DataTableCell key={column}>{column}</DataTableCell>
						))}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{unifiedApplications.map((unifiedApplication) => (
						<UnifiedApplicationRow
							key={unifiedApplication.id}
							unifiedApplication={unifiedApplication}
							orgNames={orgNames}
							includedColumns={includedColumns}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={true}
				meta={meta}
			/>
		</div>
	)
}
